export default "__VITE_ASSET__CPQ6Owq1__"